import { useMarketsState } from "src/store/features/markets.slice";
import { Grid, Typography } from "@mui/material";
import { dynamicPriceFormatter, numberFormatter } from "src/utils/helpers/PriceAndUnitsHelpers";
import { CoinHeaderStyles } from "./styles/CoinHeader.styles";

const text = {
  color: "#022B1D",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "17px",
};

export const GainComponent = (props: {
  value: string;
  variant: "gain" | "lose";
  transparent?: boolean;
}) => {
  const classes = CoinHeaderStyles();
  const isGain = props.variant === "gain";
  const arrow = isGain ? "↑" : "↓";
  return (
    <div className={isGain ? classes.increasedContainer : classes.decreasedContainer}>
      <Typography style={text} translate="no">{`${props.value}%${arrow}`}</Typography>
    </div>
  );
};

export default function CoinHeader() {
  const {
    coinStatistics: { change = 0, price, currencyConfig: { code, displayName, logoUrl } = {} },
  } = useMarketsState();

  const classes = CoinHeaderStyles();
  const variant = change < 0 ? "lose" : "gain";

  return (
    <Grid container mb={2}>
      <Grid item mr={1} sx={{ alignSelf: "end" }}>
        {logoUrl && <img src={logoUrl} alt={`${displayName} logo`} className={classes.logoImage} />}
      </Grid>
      <Grid item marginTop="4px">
        <div style={{ display: "flex", marginBottom: "5px" }}>
          <Typography mr={1} className={classes.title}>
            {displayName}
          </Typography>
          <Typography className={classes.ticker}>{code}</Typography>
        </div>
        <div style={{ display: "flex" }}>
          <Typography mr={1} className={classes.value} translate="no">
            {price ? dynamicPriceFormatter(price, "USD") : "-"}
          </Typography>{" "}
          {change && (
            <>
              <GainComponent value={numberFormatter(change)} variant={variant} />
              <Typography style={{ ...text, alignSelf: "center" }}>{"24h"}</Typography>
            </>
          )}
        </div>
      </Grid>
    </Grid>
  );
}
